import { render, staticRenderFns } from "./NumberMessageCard.vue?vue&type=template&id=22f6e4cb&scoped=true&"
import script from "./NumberMessageCard.vue?vue&type=script&lang=js&"
export * from "./NumberMessageCard.vue?vue&type=script&lang=js&"
import style0 from "./NumberMessageCard.vue?vue&type=style&index=0&id=22f6e4cb&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.2_uesoswnqfrvbmgjykhrr3r374i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f6e4cb",
  null
  
)

export default component.exports